export const styles = ({ colors, remify, shadow }) => `
    .container {
        padding: ${remify(32)};
        max-width: ${remify(1000)};
        margin: 0 auto;
        background: ${colors.white};
        border-radius: ${remify(12)};
    }

    .title {
        font-size: ${remify(28)};
        font-weight: 700;
        color: ${colors.gray[900]};
        text-align: center;
        margin-bottom: ${remify(8)};
    }

    .subtitle {
        font-size: ${remify(16)};
        color: ${colors.gray[600]};
        text-align: center;
        margin-bottom: ${remify(32)};
    }

    .current-plan {
        background: ${colors.gray[50]};
        border: ${remify(2)} solid ${colors.gray[200]};
        border-radius: ${remify(12)};
        padding: ${remify(24)};
        margin-bottom: ${remify(32)};
    }

    .current-plan-title {
        font-size: ${remify(18)};
        font-weight: 600;
        color: ${colors.gray[900]};
        margin-bottom: ${remify(16)};
    }

    .current-plan-details {
        display: flex;
        flex-direction: column;
        gap: ${remify(8)};
        font-size: ${remify(14)};
        color: ${colors.gray[700]};
    }

    .current-plan-detail {
        display: flex;
        align-items: center;
        gap: ${remify(8)};
    }

    .current-plan-label {
        font-weight: 500;
        color: ${colors.gray[600]};
    }

    .billing-toggle {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: ${remify(16)};
        margin-bottom: ${remify(40)};
    }

    .billing-toggle label {
        font-size: ${remify(14)};
        color: ${colors.gray[700]};
        font-weight: 500;
        cursor: pointer;
        user-select: none;
    }

    .billing-toggle input[type="radio"] {
        margin: 0 ${remify(4)} 0 0;
        cursor: pointer;
    }

    .savings-badge {
        display: inline-block;
        background: ${colors.lime[100]};
        color: ${colors.lime[800]};
        padding: ${remify(4)} ${remify(8)};
        border-radius: ${remify(4)};
        font-size: ${remify(12)};
        font-weight: 600;
        margin-left: ${remify(8)};
    }

    .plans-grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: ${remify(24)};
        margin-bottom: ${remify(32)};
    }

    .cancel-section {
        text-align: center;
        padding: ${remify(24)} 0;
        border-top: ${remify(1)} solid ${colors.gray[200]};
    }

    .cancel-text {
        font-size: ${remify(14)};
        color: ${colors.gray[600]};
        margin-bottom: ${remify(16)};
    }

    .cancel-link {
        color: ${colors.red[600]};
        text-decoration: underline;
        cursor: pointer;
    }

    .cancel-link:hover {
        color: ${colors.red[700]};
    }

    .usage-section {
        background: ${colors.gray[50]};
        border: ${remify(2)} solid ${colors.gray[200]};
        border-radius: ${remify(12)};
        padding: ${remify(24)};
        margin-bottom: ${remify(32)};
    }

    .usage-title {
        font-size: ${remify(18)};
        font-weight: 600;
        color: ${colors.gray[900]};
        margin-bottom: ${remify(16)};
    }

    .usage-period {
        font-size: ${remify(14)};
        color: ${colors.gray[600]};
        margin-bottom: ${remify(16)};
    }

    .usage-stats {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        margin-bottom: ${remify(8)};
    }

    .usage-count {
        font-size: ${remify(14)};
        font-weight: 500;
        color: ${colors.gray[700]};
    }

    .usage-percentage {
        font-size: ${remify(14)};
        font-weight: 600;
        color: ${colors.gray[700]};
    }

    .usage-bar-bg {
        width: 100%;
        height: ${remify(8)};
        background: ${colors.gray[200]};
        border-radius: ${remify(4)};
        overflow: hidden;
    }

    .usage-bar-fill {
        height: 100%;
        border-radius: ${remify(4)};
        background: ${colors.lime[500]};
        transition: width 0.3s ease;
    }

    .usage-warning {
        display: flex;
        align-items: flex-start;
        gap: ${remify(12)};
        margin-top: ${remify(16)};
        padding: ${remify(12)} ${remify(16)};
        background: ${colors.amber[50]};
        border: ${remify(1)} solid ${colors.amber[300]};
        border-radius: ${remify(8)};
        font-size: ${remify(14)};
        color: ${colors.amber[800]};
        line-height: 1.5;
    }

    .usage-alert {
        display: flex;
        align-items: flex-start;
        gap: ${remify(12)};
        margin-top: ${remify(16)};
        padding: ${remify(12)} ${remify(16)};
        background: ${colors.red[50]};
        border: ${remify(1)} solid ${colors.red[300]};
        border-radius: ${remify(8)};
        font-size: ${remify(14)};
        color: ${colors.red[800]};
        line-height: 1.5;
        font-weight: 500;
    }
`;

export const decorators = {
    billingToggle(){
        this.findAll('input[type="radio"]').forEach(radio => {
            radio.on('change', () => {
                const interval = radio.value;
                const root = this.parent;

                root.findAll('[data-monthly]').forEach(el => {
                    el.node.style.display = interval === 'monthly' ? 'block' : 'none';
                });
                root.findAll('[data-yearly]').forEach(el => {
                    el.node.style.display = interval === 'yearly' ? 'block' : 'none';
                });

                root.findAll('[data-interval-field]').forEach(link => {
                    const currentHref = link.node.href;
                    const url = new URL(currentHref);
                    url.searchParams.set('interval', interval);
                    link.node.href = url.toString();
                });
            });
        });
    }
};

export default {
    async render(){
        if(await this.isSignedOut){
            return this.renderRedirect({
                url: `/_actions/guest/sign_in?returnUrl=${encodeURIComponent('/_actions/admin/saas_manage_subscription')}`
            });
        }

        const tenant = await this.database.tenant;

        if(!tenant){
            return this.renderRedirect({ target: '_top' });
        }

        // Show subscription management UI
        const config = tenant.subscriptionConfig;
        const plusPlan = config.plans.plus;

        const currentPlan = tenant.subscriptionPlan || 'none';
        const currentInterval = tenant.subscriptionInterval || 'monthly';
        const isFreeTier = tenant.subscriptionTier === 'free';

        const currentPlanConfig = config.plans[currentPlan] || null;

        // Fetch email usage data
        let emailsSent = 0;
        const emailAllowance = tenant.monthlyEmailAllowance;
        if(this.database.info.emailUsages){
            const usage = await tenant.emailUsageForCurrentPeriod;
            emailsSent = usage.emailsSent;
        }
        const usagePercent = emailAllowance > 0 ? Math.min(Math.round((emailsSent / emailAllowance) * 100), 100) : 0;
        const now = new Date();
        const periodLabel = now.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

        return this.renderHtml`
            <blognami-modal width="medium" height="full">
                <div class="${this.cssClasses.container}">
                    <h1 class="${this.cssClasses.title}">Manage Subscription</h1>
                    <p class="${this.cssClasses.subtitle}">Update your plan</p>

                    ${currentPlanConfig ? this.renderHtml`
                        <div class="${this.cssClasses.currentPlan}">
                            <div class="${this.cssClasses.currentPlanTitle}">Current Subscription</div>
                            <div class="${this.cssClasses.currentPlanDetails}">
                                <div class="${this.cssClasses.currentPlanDetail}">
                                    <span class="${this.cssClasses.currentPlanLabel}">Plan:</span>
                                    <span>${currentPlanConfig.name}</span>
                                </div>
                                <div class="${this.cssClasses.currentPlanDetail}">
                                    <span class="${this.cssClasses.currentPlanLabel}">Billing:</span>
                                    <span>${currentInterval === 'monthly' ? 'Monthly' : 'Annual'}</span>
                                </div>
                                <div class="${this.cssClasses.currentPlanDetail}">
                                    <span class="${this.cssClasses.currentPlanLabel}">Price:</span>
                                    <span>$${currentInterval === 'monthly' ? currentPlanConfig.monthlyPrice : Math.round(currentPlanConfig.yearlyPrice / 12)}/month${currentInterval === 'yearly' ? ' (billed annually at $' + currentPlanConfig.yearlyPrice + ')' : ''}</span>
                                </div>
                            </div>
                        </div>
                    ` : ''}

                    <div class="${this.cssClasses.usageSection}">
                        <div class="${this.cssClasses.usageTitle}">Email Usage</div>
                        <div class="${this.cssClasses.usagePeriod}">${periodLabel}</div>
                        <div class="${this.cssClasses.usageStats}">
                            <span class="${this.cssClasses.usageCount}">${emailsSent.toLocaleString()} / ${emailAllowance.toLocaleString()} emails sent</span>
                            <span class="${this.cssClasses.usagePercentage}">${usagePercent}%</span>
                        </div>
                        <div class="${this.cssClasses.usageBarBg}">
                            <div class="${this.cssClasses.usageBarFill}" style="width: ${usagePercent}%"></div>
                        </div>
                        ${usagePercent >= 100 ? this.renderHtml`
                            <div class="${this.cssClasses.usageAlert}">
                                You've reached your monthly email limit. Emails are paused until next month.
                            </div>
                        ` : usagePercent >= 80 ? this.renderHtml`
                            <div class="${this.cssClasses.usageWarning}">
                                You've used ${usagePercent}% of your monthly email allowance (${emailsSent.toLocaleString()} / ${emailAllowance.toLocaleString()}).
                            </div>
                        ` : ''}
                    </div>

                    ${isFreeTier ? this.renderHtml`
                        <div class="${this.cssClasses.billingToggle}">
                            <label>
                                <input type="radio" name="billing" value="monthly" ${currentInterval === 'monthly' ? 'checked' : ''}>
                                Monthly
                            </label>
                            <label>
                                <input type="radio" name="billing" value="yearly" ${currentInterval === 'yearly' ? 'checked' : ''}>
                                Annual
                                <span class="${this.cssClasses.savingsBadge}">Save 20%</span>
                            </label>
                        </div>
                    ` : ''}

                    <div class="${this.cssClasses.plansGrid}">
                        ${this.renderView('_plan_card', {
                            name: plusPlan.name,
                            monthlyPrice: plusPlan.monthlyPrice,
                            yearlyPrice: plusPlan.yearlyPrice,
                            currentInterval,
                            features: plusPlan.features,
                            isCurrent: currentPlan === 'plus',
                            button: isFreeTier ? this.renderView('_button', {
                                tagName: 'a',
                                href: `/_actions/admin/saas_subscribe?tenantId=${tenant.id}&plan=plus&interval=${currentInterval}`,
                                target: '_overlay',
                                'data-method': 'post',
                                'data-interval-field': '',
                                body: 'Upgrade to Plus',
                                isPrimary: true,
                                isFullWidth: true,
                                size: 'large'
                            }) : this.renderView('_button', {
                                tagName: 'a',
                                href: `/_actions/admin/saas_manage_subscription/update_plan?plan=plus&interval=${currentInterval === 'monthly' ? 'yearly' : 'monthly'}`,
                                target: '_overlay',
                                'data-method': 'post',
                                body: currentInterval === 'monthly' ? 'Switch to annual billing' : 'Switch to monthly billing',
                                isPrimary: true,
                                isFullWidth: true,
                                size: 'large'
                            })
                        })}
                    </div>

                    ${!isFreeTier ? this.renderHtml`<div class="${this.cssClasses.cancelSection}">
                        <p class="${this.cssClasses.cancelText}">Need to cancel your subscription?</p>
                        <a href="/_actions/admin/saas_unsubscribe" class="${this.cssClasses.cancelLink}" data-test-id="saas-unsubscribe" data-confirm="Are you sure you want to cancel your subscription?">Cancel Subscription</a>
                    </div>` : ''}

                </div>
            </blognami-modal>
        `;
    }
};
